// extracted by mini-css-extract-plugin
export var locationCard = "_fv-0";